import React from 'react';
import { FadeIn } from './Shared';
import { Quote } from 'lucide-react';
interface TestimonialProps {
  quote: string;
  author: string;
  location: string;
}
const TestimonialCard = ({
  quote,
  author,
  location
}: TestimonialProps) => <div className="bg-navy-800/50 p-6 md:p-8 rounded-2xl border border-navy-700 relative flex flex-col h-full" data-id="element-314">
    <Quote className="absolute top-6 right-6 w-8 h-8 text-navy-600 opacity-50" data-id="element-315" />
    <div className="text-yellow-400 mb-4 text-sm drop-shadow-[0_0_8px_rgba(250,204,21,0.3)]" data-id="element-316">
      ⭐⭐⭐⭐⭐
    </div>
    <p className="text-base md:text-lg text-white italic mb-6 relative z-10 flex-grow" data-id="element-317">
      "{quote}"
    </p>
    <div data-id="element-318">
      <div className="font-bold text-white" data-id="element-319">{author}</div>
      <div className="text-xs md:text-sm text-gray-200" data-id="element-320">{location}</div>
    </div>
  </div>;
export const Testimonials = () => {
  return <section className="py-8 md:py-12 px-4" data-id="element-321">
      <div className="max-w-6xl mx-auto" data-id="element-322">
        <FadeIn data-id="element-323">
          <div className="grid md:grid-cols-3 gap-6" data-id="element-324">
            <TestimonialCard quote="Llevábamos meses sin dormir bien. Lo probamos todo y nada duraba más de dos días. Con el Tomo 3 entendimos que el problema era el horario, no el bebé. Tardamos una semana en ver un cambio real, pero cuando llegó fue un antes y un después." author="Valeria R., mamá de Sofía (8 meses)" location="Buenos Aires" data-id="element-325" />
            <TestimonialCard quote="Lo que más me sirvió fue el Manual de Crisis. No para resolver todo de golpe, sino para no entrar en pánico a las 3 AM. Tener un protocolo claro cambia mucho cómo vivís esas noches." author="Melisa S., mamá de Mateo (11 meses)" location="Córdoba" data-id="element-326" />
            <TestimonialCard quote="Mi pareja y yo teníamos enfoques distintos y eso generaba más caos. El sistema nos alineó. No es que el bebé cambió de un día para el otro, pero nosotros sí cambiamos cómo manejamos las noches." author="Julián P., papá de Luca (9 meses)" location="Rosario" data-id="element-327" />
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const MoreTestimonials = () => {
  return <section className="py-8 md:py-12 px-4 bg-navy-800/30" data-id="element-328">
      <div className="max-w-4xl mx-auto" data-id="element-329">
        <FadeIn data-id="element-330">
          <h2 className="text-xl md:text-3xl font-serif font-bold text-center text-white mb-8" data-id="element-331">
            <span className="text-red-500 mr-2" data-id="element-332">❤️</span> MÁS FAMILIAS QUE YA
            DUERMEN MEJOR
          </h2>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-333">
            <TestimonialCard quote="Mi pareja y yo teníamos estrategias distintas y eso arruinaba todo. El sistema nos alineó en una semana." author="Julián P." location="Rosario" data-id="element-334" />
            <TestimonialCard quote="El Manual de Crisis a las 3 AM es lo que toda mamá necesita tener en el celular." author="Carolina R." location="Mendoza" data-id="element-335" />
          </div>
        </FadeIn>
      </div>
    </section>;
};